import { useState } from "react";
import {
  BarChart3,
  BookOpen,
  ClipboardList,
  GraduationCap,
  PencilLine,
  Shield,
  User,
  Volume2,
  Wrench,
} from "lucide-react";
import type { AgentRole } from "@/lib/api";

const ROLE_ICON: Record<string, typeof User> = {
  bart: GraduationCap,
  corka: User,
  glos: Volume2,
  architekt: BookOpen,
  narzedziarka: Wrench,
  analityczka: BarChart3,
  straznik: Shield,
  szef: ClipboardList,
  redaktor: PencilLine,
};

export default function ZespolTeamStrip({
  roster,
  hint,
}: {
  roster: AgentRole[];
  hint?: string;
}) {
  const [openId, setOpenId] = useState<string | null>(null);
  const open = roster.find((role) => role.id === openId) || null;

  return (
    <section>
      <p className="text-sm font-medium text-slate-900">Kto słucha</p>
      <p className="mt-1 text-sm text-slate-600">
        {hint || "Bart mówi pierwszy. Strażnik pilnuje Kasi. Szef zamyka tydzień."}
      </p>
      <div className="-mx-1 mt-4 flex gap-2 overflow-x-auto pb-1 sm:flex-wrap sm:overflow-visible">
        {roster.map((role) => {
          const Icon = ROLE_ICON[role.id] ?? User;
          const on = role.id === openId;
          return (
            <button
              key={role.id}
              type="button"
              aria-expanded={on}
              onClick={() => setOpenId((cur) => (cur === role.id ? null : role.id))}
              className={`flex min-h-11 shrink-0 items-center gap-2 rounded-full border px-3 py-2 text-left text-sm shadow-sm transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/30 ${
                on
                  ? "border-brand bg-white text-slate-900 ring-2 ring-brand/20"
                  : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900"
              }`}
            >
              <Icon className="h-3.5 w-3.5 shrink-0" />
              <span className="font-medium text-slate-900">{role.label}</span>
            </button>
          );
        })}
      </div>
      {open && (
        <p className="mt-3 rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-600 shadow-sm">
          <span className="font-medium text-slate-900">{open.axis}. </span>
          Słucha: {open.source}. Nie: {open.forbidden}.
        </p>
      )}
    </section>
  );
}
